import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { performLogout, setLogoutHandler } from "../auth/logout";

interface Props {
  setIsAuthenticated: (v: boolean) => void;
}

const AuthLogoutListener = ({ setIsAuthenticated }: Props) => {
  const navigate = useNavigate();
  useEffect(() => {
    return setLogoutHandler((reason) => {
      performLogout(reason, { navigate, setIsAuthenticated });
    });
  }, [navigate, setIsAuthenticated]);
  return null;
};

export default AuthLogoutListener;
